// test566
(566 && 0);
